import { DATASOURCES, NEW } from 'Features/routePaths';
import { getStationPath } from 'Features/StationsNew/Station/Components';
import { DatasourceType, DatasourceTypeType } from 'Services/api/v2';

export type ExtendedDatasourceType = DatasourceType & {
  datasourceTypeShortName?: string,
  datasourceTypeFullName?: string,
  datasourceTypeKod?: string,
}
export type ExtendedDatasourceProps = { datasource: ExtendedDatasourceType }
export type DatasourceIdProps = { datasourceId: number }

/** путь до источника: `/stations/${stationId}/datasources/${datasourceId}` */
export const getStationDatasourcePath = ({ stationId, datasourceId }: {stationId: number, datasourceId:number | typeof NEW}) => {
  return `${getStationPath(stationId)}/${DATASOURCES}/${datasourceId}`;
};

export const isHydropad = (datasourceShortName?: string) => datasourceShortName?.toUpperCase() === 'HYDROPAD';
export const HYDRPAD_DATASOURCE_TYPE_ID = 1;

/** расширенные источник с названиями из типа источника */
export const getExtendedDatasource = (datasource: DatasourceType, datasourceType: DatasourceTypeType):ExtendedDatasourceType => {
  return {
    ...datasource,
    datasourceTypeShortName: datasourceType.shortName,
    datasourceTypeFullName: datasourceType.fullName,
    datasourceTypeKod: datasourceType.kod,
  };
};
